<template>
  <div>
    <breadcrumb :list='breadcrumbList'></breadcrumb>
    <el-card class='main'>
      <el-form ref='searchEmp' :model='searchEmp' class='searchEmp'>
        <el-row>
          <el-col :xs='24' :sm='12' :md='6' :lg='6'>
            <el-form-item label-width='75px'>
              <div slot='label'>填报人</div>
              <el-input v-model='searchEmp.djrxm' size='large'></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='{ span: 7, offset: 1 }' :lg='7'>
            <el-form-item label-width='75px'>
              <div slot='label'>填报时间</div>
              <el-date-picker v-model='searchEmp.time' type='datetimerange' align='right' start-placeholder='开始日期'
                end-placeholder='结束日期' :default-time="['00:00:00', '23:59:59']" value-format='timestamp'
                style='width:100%'>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='10' :lg='10' style='float:right'>
            <el-row style='text-align:end;width:100%'>
              <el-button type='success' @click='add'> 新增</el-button>
              <el-button type='info' @click='clean_btn'>重置</el-button>
              <el-button type='primary' @click='search_btn'>查询</el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <Total :total='total'></Total>

      <!-- 表格 -->

      <el-table :data='tableData' style='width: 100%' :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
        @cell-click='cellClick'>
        <el-table-column prop='kyqkdjxh' label='可疑情况序号' min-width='180' align='center'>
        </el-table-column>
        <el-table-column prop='kyqklxdm' label='可疑情况类型' min-width='180' align='center' :formatter='kyqkFliter'>
        </el-table-column>
        <el-table-column prop='kyqk_jyms' label='疑点详情描述' min-width='120' align='center'>
        </el-table-column>
        <el-table-column prop='djrxm' label='填报人姓名' min-width='100' align='center'>
        </el-table-column>
        <el-table-column prop='djrdh' label='填报电话' min-width='130' align='center'>
        </el-table-column>
        <el-table-column prop='create_time' label='填报时间' min-width='160' align='center'>
        </el-table-column>
        <el-table-column prop='jiancha' label='操作' align='center' fixed="right">
          <template slot-scope='scope'>
            <el-button class='revise' size='mini' type='warning' plain @click.stop='revise(scope.row)'>修改</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->

      <div class='page'>
        <el-pagination v-if='tableData.length != 0' class='fy' style='' layout='prev, pager, next' :total='total'
          :page-size='pageData.page_size' :current-page='pageData.page_no' @current-change='current_change' background>
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { getkyqklist } from '@/api/day_work.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'

export default {
  name: 'SuspiciousIndex',
  data() {
    return {
      breadcrumbList: [
        { name: '可疑情况', path: 'suspicious' }
      ],
      searchEmp: {},
      tableData: [],
      kyqkList: [],
      total: 0,
      pageData: {
        // count: null, //总数
        page_no: 1,  //现在
        page_size: 10 //每页条数
        // page:25 //总页数
      },
      loading: true
    }
  },
  created() {
    this.info()
  },
  methods: {
    async info() {
      const res = await getkyqklist({ ...this.pageData, ...this.searchEmp })
      this.total = res.total_result
      this.pageData.page_no = res.page_no
      this.pageData.page_size = res.page_size
      this.tableData = res.items
      // 获取字典
      this.kyqkList = lists['KYLX']


    },
    add() {
      this.$router.push('/suspicious/add_suspicious')
    },
    revise({ id }) {
      this.$router.push({
        path: '/suspicious/add_suspicious',
        query: { id }
      })

    },
    clean_btn() { //重置
      this.searchEmp = {}
      this.info()
    },
    search_btn() {//查询
      // 当前页强制转为1
      this.pageData.page_no = 1
      const time = this.searchEmp.time
      this.searchEmp.start_time = time ? time[0] / 1000 : ''
      this.searchEmp.end_time = time ? time[1] / 1000 : ''
      this.info()
    },
    cellClick({ id }) { //点击单元格,跳转详情
      this.$router.push({
        path: '/suspicious/suspicious_details',
        query: { id }
      })
    },
    current_change(val) { //分页功能
      this.pageData.page_no = val
      this.info()
    },
    kyqkFliter(row, col, val) {
      if (!val && val != 0) return
      return filtersInfo(this.kyqkList, val)
    }
  },
  beforeRouteLeave(to, from, next) {
    //离开页面如果去的详情 || 修改  则缓存当前页面
    if (to.path === '/suspicious/suspicious_details' ||
      to.path === '/suspicious/add_suspicious') {
      this.$store.commit('setKeep', 'SuspiciousIndex')
      next()
    } else {
      this.$store.commit('setKeep', '')
      next()
    }
    next()
  },
  components: { Total }
}
</script>

<style lang='less' scoped>
.revise {
  border-radius: 16px;
}
</style>